import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { publishDeviceClass } from "./lib/device";
import "./index.css";

// Device sensing (2026-11-04): tag <html data-device="desktop|ipad|iphone|android">
// before first paint so the desktop scrollbar rules in index.css apply at once.
publishDeviceClass();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
